export default "__VITE_ASSET__BbeAtwPJ__"